export const ProcesoAdmin = [
    {
        codigo: 1,
        nombre: "CREAR"
    },
    {
        codigo: 2,
        nombre: "ACTUALIZAR"
    },
    {
        codigo: 3,
        nombre: "BORRAR"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/ProcesoAdmin.ts